import Ax from './axios';
import config from '../const/config';


const API = config.SERVICE_API;
// 查询城市套餐配置
export function getPackages(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.user.city.config.v2',
  });
}

// 查询城市套餐配置
export function getPackagesV3(data) {
  return Ax.post(API, {
    ...data,
    // action: 'switchpower.user.city.config.v3',
    action: 'switchpower.user.commodityservice.get.commodity.list',
  });
}

// 查询城市押金配置
export function getCityDeposit(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.user.city.deposits',
  });
}

// 新押金页——获取押金信息 https://yapi.hellobike.cn/project/1649/interface/api/266000
export function queryDepositInfo(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.deposit.show',
  }).then((res) => res.data);
}

export function getCityOpenBiz(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.city.open.biz',
  });
}

// 查询套餐保险配置
export async function queryInsuranceConfig(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.user.city.Insurance.config',
  });
}

// banne城市配置
export async function getBanner(data) {
  return Ax.post(API, {
    ...data,
    action: 'switchpower.user.city.preferentialBanner',
  });
}
